import { render, staticRenderFns } from "./ClientId.vue?vue&type=template&id=bf3b43c0&"
import script from "./ClientId.vue?vue&type=script&lang=js&"
export * from "./ClientId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports